'use client'
import React from 'react'

import {
  MediaAudioTrackMenu
} from 'media-chrome/react/menu'

export default function MediaAudioSettingsMenuComponent () {
  return (
    <MediaAudioTrackMenu anchor='auto' hidden=''>
      <div slot='header'>Audio</div>
    </MediaAudioTrackMenu>
  )
}
